import { Controller } from "@hotwired/stimulus"

// Bottom sheet mobile de la page carte (voir .mobile-sheet dans le CSS).
// Replié par défaut : la carte reste visible, seule la poignée dépasse.
// Sans effet sur desktop (les styles ne s'appliquent qu'en dessous de md).
export default class extends Controller {
  static targets = ["chevron"]

  toggle() {
    this.element.classList.toggle("sheet-open")
    this.syncChevron()
  }

  open() {
    this.element.classList.add("sheet-open")
    this.syncChevron()
  }

  // Appelé quand l'utilisateur lance une action "carte" (recherche, résultat
  // cliqué…) : on replie pour laisser voir le résultat sur la carte.
  collapse() {
    this.element.classList.remove("sheet-open")
    this.syncChevron()
  }

  syncChevron() {
    if (!this.hasChevronTarget) return
    this.chevronTarget.classList.toggle("rotate-180", this.element.classList.contains("sheet-open"))
  }
}
